import React from 'react';
import dialog from 'utils/dialog';
// @ts-ignore
import OrderDialogStore from '../../../../../orderDialog/store.js';
import { TARGET_TYPE_KV, DEMAND_TYPE_KV, JOIN_STATUS_KV } from '../../../constants/index';
import { OverlayTrigger, PopOver, Icon } from '@tencent/spaui';
import { post } from 'store/request';

const getAllColumns = ({ csIndustryTreeHash }) => [
  {
    name: 'target',
    title: '需求目标', // TARGET_TYPE_KV
    maxWidth: 80,
    render: (type, name, value, data) => (
      <div>
        <span>{TARGET_TYPE_KV[value]}</span>
        {!!data.if_invite && (
          <span
            style={{
              fontSize: '12px',
              padding: '2px 4px',
              borderRadius: '8px',
              border: '1px solid #eee',
              color: '#296bef',
              display: 'inline-block',
              background: 'white',
              marginLeft: '8px',
            }}
          >
            平台邀请
          </span>
        )}
      </div>
    ),
  },
  {
    name: 'type', // DEMAND_TYPE_KV
    title: '需求类型',
    render: (type, name, value) => {
      return <div>{DEMAND_TYPE_KV[value]}</div>;
    },
  },
  {
    name: 'tender_status',
    title: (
      <div>
        <OverlayTrigger
          placement="bottom"
          overlay={
            <PopOver>
              <div>
                <span style={{ fontWeight: 'bolder' }}>未参与：</span>您未参与此次需求。
              </div>
              <div>
                <span style={{ fontWeight: 'bolder' }}>参与中：</span>
                您已点击【立即参与】，需求方目前未确认是否加入比标名单。
              </div>
              <div>
                <span style={{ fontWeight: 'bolder' }}>竞标中：</span>
                需求方已选中您参与此次需求比标，请及时联系客户跟进方案提报。
              </div>
              <div>
                <span style={{ fontWeight: 'bolder' }}>评标中：</span>
                您参与的需求正在进行比标评选，请与客户联系跟进项目。
              </div>
              <div>
                <span style={{ fontWeight: 'bolder' }}>已中标：</span>
                您的方案在此次评比中胜出，请及时与客户沟通合同事项并上传。
              </div>
              <div>
                <span style={{ fontWeight: 'bolder' }}>未中标：</span>
                需求方未选中您参与此次需求比标，或您的方案在此次评比中未选中，流程结束。
              </div>
            </PopOver>
          }
        >
          <div>
            参与状态
            <Icon
              style={{
                cursor: 'pointer',
                verticalAlign: 'text-bottom',
                width: '14px',
                marginLeft: '4px',
              }}
              name="question-filled"
            />
          </div>
        </OverlayTrigger>
      </div>
    ),
    render: (type, name, value) => <div>{JOIN_STATUS_KV[value]}</div>,
  },
  {
    name: 'budget',
    title: '客户预算',
    render: (type, name, value) => <div>{value}</div>,
  },
  {
    name: 'company_industry',
    title: '所在行业',
    render: (type, name, value) => <div>{csIndustryTreeHash?.[value]}</div>,
  },
  {
    name: 'company_name',
    title: (
      <div>
        <OverlayTrigger placement="top" overlay={<PopOver>竞标后可查看</PopOver>}>
          <div>
            公司名称
            <Icon
              style={{
                cursor: 'pointer',
                verticalAlign: 'text-bottom',
                width: '14px',
                marginLeft: '4px',
              }}
              name="question-filled"
            />
          </div>
        </OverlayTrigger>
      </div>
    ),
    render: (type, name, value) => <div>{value}</div>,
  },
  {
    name: 'contact_telephone',
    title: (
      <div>
        <OverlayTrigger placement="top" overlay={<PopOver>竞标后可查看</PopOver>}>
          <div>
            联系方式
            <Icon
              style={{
                cursor: 'pointer',
                verticalAlign: 'text-bottom',
                width: '14px',
                marginLeft: '4px',
              }}
              name="question-filled"
            />
          </div>
        </OverlayTrigger>
      </div>
    ),
    render: (type, name, value) => <div>{value}</div>,
  },
  {
    name: 'content',
    title: '需求详情',
    render: (type, name, value) => (
      <div>
        <OverlayTrigger placement="top" overlay={<PopOver>{value}</PopOver>}>
          <span className="break-detail">{value?.length > 10 ? `${value?.slice(0, 10)} ...` : value}</span>
        </OverlayTrigger>
      </div>
    ),
  },
  {
    name: 'created_at',
    title: '发布时间',
    render: (type, name, value) => <div>{value}</div>,
  },
  {
    name: 'tender_expect_deadline',
    title: '截止时间',
    render: (type, name, value) => <div>{value}</div>,
  },
];

// // 查看合同
const getHetong = (params) => {
  return post(
    '/demand/get_demand_material/',
    {
      ...params,
      type: 3,
    },
    'v2'
  ).then((res) => {
    return res.map((item) => ({
      url: item.path,
      name: item.name,
      status: 'success',
      file_name: item.name,
      file_url: item.path,
    }));
  });
};

// 查看补充资料
const getZiliao = (params) => {
  return post(
    '/demand/get_demand_material/',
    {
      ...params,
      type: 2,
    },
    'v2'
  ).then((res) => {
    return res.map((item) => ({
      url: item.path,
      name: item.name,
      status: 'success',
      file_name: item.name,
      file_url: item.path,
    }));
  });
};

// 参与状态
//   export const JOIN_STATUS_KV = {
//     1: '参与中',
//     2: '未参与',
//     3: '竞标中', // 已选中
//     4: '评标中',
//     5: '已中标', // 已中标
//     6: '未中标',
//   };

export default (props) => {
  const { setContractDialog, setUpdateFileDialog, changeJoinState, chooseState, csIndustryTreeHash } = props;
  const allColumns = getAllColumns({ csIndustryTreeHash });

  return {
    emptyText: '暂无相关数据记录',
    defaultPageSize: 50,
    paginationConfig: {
      showTotalPage: true,
    },
    columns: allColumns,
    operations: {
      maxWidth: 120,
      columnAction: (data) => {
        return [
          <div key="">
            <span
              onClick={() => {
                OrderDialogStore.viewData(data.id, true);
              }}
              style={{ color: '#296bef', cursor: 'pointer', marginRight: '8px' }}
            >
              查看
            </span>
            {/* 未参与 if_expired 需求是否过期字段，0未过期， 1 已过期 */}
            {data.tender_status === 2 && data.if_expired === 0 && (
              <span
                onClick={() => {
                  dialog
                    .confirm('确认参与吗？')
                    .then(() => changeJoinState(data, true))
                    .catch(() => {});
                }}
                style={{ color: '#296bef', cursor: 'pointer', marginRight: '8px' }}
              >
                立即参与
              </span>
            )}
            {/* 参与中 */}
            {data.tender_status === 1 && (
              <span
                onClick={() => {
                  dialog
                    .confirm('确认取消参与？')
                    .then(() => changeJoinState(data, false))
                    .catch(() => {});
                }}
                style={{ color: '#296bef', cursor: 'pointer', marginRight: '8px' }}
              >
                取消参与
              </span>
            )}
            {/* 评标中 */}
            {data.tender_status === 4 && (
              <span
                onClick={() => {
                  dialog
                    .confirm('确认中标？')
                    .then(() => chooseState(data, true))
                    .catch(() => {});
                }}
                style={{ color: '#296bef', cursor: 'pointer', marginRight: '8px' }}
              >
                确认中标
              </span>
            )}
            {/* 已中标、已中标 && if_contract 1代表当前需求处于合同阶段 无需展示取消中标按钮 */}
            {data.tender_status === 5 && data.if_contract !== 1 && (
              <span
                onClick={() => {
                  dialog
                    .confirm('确认取消中标？')
                    .then(() => chooseState(data, false))
                    .catch(() => {});
                }}
                style={{ color: '#296bef', cursor: 'pointer', marginRight: '8px' }}
              >
                取消中标
              </span>
            )}

            {/* 已中标、已中标 */}
            {data.tender_status === 5 && (
              <span
                onClick={() => {
                  console.log('上传合同', data);
                  getHetong({
                    demand_id: data.id,
                  }).then((res) => {
                    setContractDialog({
                      show: true,
                      list: [...res],
                      data,
                    });
                  });
                  // setContractDialog({
                  //   show: true,
                  //   list: [
                  //     {
                  //       url: 'http://pgdt.gtimg.cn/gdt/0/95788d61141c4ec8bd533a6a77716787.IMG/0?ck=bfafcd488af790bff153f60e77d366e0',
                  //       name: '123123.jpg',
                  //       status: 'success',
                  //       file_name: '123123.jpg',
                  //       file_url:
                  //         'http://pgdt.gtimg.cn/gdt/0/95788d61141c4ec8bd533a6a77716787.IMG/0?ck=bfafcd488af790bff153f60e77d366e0',
                  //     },
                  //   ],
                  //   data,
                  // });
                }}
                style={{ color: '#296bef', cursor: 'pointer', marginRight: '8px' }}
              >
                上传合同
              </span>
            )}

            <span
              onClick={() => {
                console.log('上传资料', data);
                getZiliao({
                  demand_id: data.id,
                }).then((res) => {
                  setUpdateFileDialog({
                    show: true,
                    list: [...res],
                    data,
                  });
                });
                // setUpdateFileDialog({
                //   show: true,
                //   list: [
                //     {
                //       url: 'http://pgdt.gtimg.cn/gdt/0/95788d61141c4ec8bd533a6a77716787.IMG/0?ck=bfafcd488af790bff153f60e77d366e0',
                //       name: '123123.jpg',
                //       status: 'success',
                //       file_name: '123123.jpg',
                //       file_url:
                //         'http://pgdt.gtimg.cn/gdt/0/95788d61141c4ec8bd533a6a77716787.IMG/0?ck=bfafcd488af790bff153f60e77d366e0',
                //     },
                //   ],
                //   data,
                // });
              }}
              style={{ color: '#296bef', cursor: 'pointer', marginRight: '8px' }}
            >
              上传资料
            </span>
          </div>,
        ];
      },
    },
  };
};
